export const dsa = {
  DSAAutoTargetPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'DynamicAdTarget',
      'Language',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AveragePosition',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Spend',
    ],
    mandatory: [
      'DynamicAdTarget',
    ],
  },
  DSACategoryPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Category1',
      'Category2',
      'Category0',
      'Language',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AveragePosition',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Spend',
    ],
    mandatory: [
      'Category1',
      'Category2',
      'Category0',
    ],
  },
  DSASearchQueryPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'SearchQuery',
      'DynamicAdTarget',
      'Language',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AveragePosition',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Spend',
    ],
    mandatory: [
      'SearchQuery',
    ],
  },
};

